export enum ElementGroupNames {
    Superstructure = 'superstructure',
    Substructure = 'substructure',
    Foundation = 'foundation',
}
